import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ClientsService } from '../clients.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.scss'],
})
export class AddClientComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;
  helper = helper;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    observations: new FormControl(''),
    logo_small: new FormControl('', [Validators.required]),
    logo_large: new FormControl('', [Validators.required]),
    bg_color: new FormControl('#f44336', [Validators.required]),
    display_name: new FormControl('', [Validators.required]),
  });

  constructor(
    private dialogRef: MatDialogRef<AddClientComponent>,
    private clientsService: ClientsService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.clientsService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const newClient = {
      name: this.form.get('name')?.value,
      observations: this.form.get('observations')?.value,
      logo_small: this.form.get('logo_small')?.value,
      logo_large: this.form.get('logo_large')?.value,
      bg_color: this.form.get('bg_color')?.value,
      display_name: this.form.get('display_name')?.value,
    };

    this.clientsService
      .addClient(newClient)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
